"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuthFlow } from "../../auth-flow-context";
import { AuthMethodId } from "../../types";
import React, { useState } from "react";
import { Button, Input } from "@/components/ui";
import { Label } from "@/components/ui/label";
import PhoneNumberInput from "@/components/ui/phone-number-input";
import { cx } from "@/lib/tailwind-utils";
import { PhoneAuthStep, usePhoneAuth } from "./phone-auth-context";
import { usePhoneCodeCooldown } from "./use-phone-code-cooldown";
type PhoneEntryProps = {
  className?: string;
};
export function PhoneEntry(t0) {
  const $ = _c(25);
  const {
    className
  } = t0;
  const {
    state,
    actions
  } = usePhoneAuth();
  const phoneError = useAuthFlow().state.errors[AuthMethodId.PHONE];
  const [phoneNumber, setPhoneNumber] = useState(state.phoneNumber);
  const {
    isCoolingDown,
    secondsRemaining,
    startCooldown
  } = usePhoneCodeCooldown();
  if (state.step !== PhoneAuthStep.ENTER_PHONE) {
    return null;
  }
  let t1;
  if ($[0] !== phoneNumber) {
    t1 = phoneNumber?.trim() && phoneNumber?.replace(/\D/g, "").length === 10;
    $[0] = phoneNumber;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isFormValid = t1;
  let t2;
  if ($[2] !== actions || $[3] !== isCoolingDown || $[4] !== phoneNumber || $[5] !== startCooldown) {
    t2 = async e => {
      e.preventDefault();
      if (isCoolingDown) {
        return;
      }
      startCooldown();
      await actions.submitPhone(phoneNumber);
    };
    $[2] = actions;
    $[3] = isCoolingDown;
    $[4] = phoneNumber;
    $[5] = startCooldown;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleSubmit = t2;
  let t3;
  if ($[7] !== className) {
    t3 = cx("space-y-4 w-full", className);
    $[7] = className;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="absolute left-0 top-0 opacity-0"><Input placeholder="First Name" /></div>;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Label htmlFor="phoneNumber" mandatory={true}>Phone Number</Label>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = phoneNumber || "";
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = e_0 => setPhoneNumber(e_0.target.value);
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = !!phoneError;
  let t9;
  if ($[12] !== phoneError || $[13] !== t6 || $[14] !== t8) {
    t9 = <div className="space-y-1">{t5}<PhoneNumberInput id="phoneNumber" placeholder="Phone Number" value={t6} onChange={t7} hasError={t8} errorMessage={phoneError} /></div>;
    $[12] = phoneError;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = !isFormValid || state.isSendingCode || isCoolingDown;
  const t11 = isCoolingDown ? `Try again in ${secondsRemaining}s` : "Send Verification Code";
  let t12;
  if ($[16] !== state.isSendingCode || $[17] !== t10 || $[18] !== t11) {
    t12 = <Button variant="primary" type="submit" className="w-full" disabled={t10} isLoading={state.isSendingCode} loadingText="Sending...">{t11}</Button>;
    $[16] = state.isSendingCode;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== handleSubmit || $[21] !== t12 || $[22] !== t3 || $[23] !== t9) {
    t13 = <form onSubmit={handleSubmit} className={t3}>{t4}{t9}{t12}</form>;
    $[20] = handleSubmit;
    $[21] = t12;
    $[22] = t3;
    $[23] = t9;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
}